import { AMPEL, POSITION_TEXT, meinungsbildFuerTop } from "../hilfen/auswertung";
import { useDemo } from "../zustand/DemoZustand";

/*
  Drei kleine Punkte mit Zahlen — der Stand der Fraktion zu einem
  Tagesordnungspunkt, auf einen Blick.

  Sie stehen in der Tagesordnung, damit man beim Durchsehen sofort erkennt, wo
  die Fraktion einig ist und wo nicht. Ein gespaltener Punkt sieht anders aus
  als ein glatter, ohne dass man ihn öffnen muss.

  Die Zahl steht in jedem Punkt. Damit funktioniert die Anzeige auch für
  jemanden, der Rot und Grün nicht auseinanderhält — und sie sagt mehr als
  eine Farbe je könnte, nämlich wie viele.
*/

export default function Ampelpunkte({ top }) {
  const { stammdaten, zustand } = useDemo();
  const mb = meinungsbildFuerTop(zustand, stammdaten, top.id);

  if (mb.anzahlGeaeussert === 0) return null;

  const beschreibung = AMPEL.map(
    (a) => `${mb[a.position].length} ${POSITION_TEXT[a.position].toLowerCase()}`
  ).join(", ");

  return (
    <span className="ampelpunkte" title={beschreibung} aria-label={`Meinungsbild: ${beschreibung}`}>
      {AMPEL.map((a) => (
        <span key={a.ampel} className={`ampelpunkt ampelpunkt--${a.ampel}`} aria-hidden="true">
          {mb[a.position].length}
        </span>
      ))}
    </span>
  );
}
